var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnarchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 59 59",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.44 12.92-9.8-12A2.49 2.49 0 0 0 46.71 0H12.3a2.52 2.52 0 0 0-1.94.92l-9.79 12A2.49 2.49 0 0 0 0 14.5v34A10.51 10.51 0 0 0 10.5 59h38A10.51 10.51 0 0 0 59 48.5v-34a2.54 2.54 0 0 0-.56-1.58zM39.27 35.27a2.49 2.49 0 0 1-1.77.73 2.45 2.45 0 0 1-1.76-.73L32 31.54v15a2.5 2.5 0 0 1-5 0v-15l-3.73 3.73a2.5 2.5 0 1 1-3.53-3.53l8-8a2.85 2.85 0 0 1 .6-.45 2.52 2.52 0 0 1 2.75.28l.18.17.16.17 7.84 7.83a2.49 2.49 0 0 1 0 3.53zM7.77 12l5.72-7h32l5.72 7z",
    "data-name": "Layer 1",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveIcon);
export default __webpack_public_path__ + "static/media/UnarchiveIcon.c520d70173d9c2fa8eb12aa4126f340e.svg";
export { ForwardRef as ReactComponent };